import type { Control, UseFormHandleSubmit } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextareaControlled } from '@/components/form/textarea-controlled';
import { Button } from '@/components/ui/button';
import type {
  PurchaseOrderCommentInput,
  PurchaseOrderCommentValues,
} from '@/features/purchase-order/schema/purchase-order-comment-schema';

type PurchaseOrderMainCommentFormProps = {
  control: Control<
    PurchaseOrderCommentInput,
    unknown,
    PurchaseOrderCommentValues
  >;
  handleSubmit: UseFormHandleSubmit<PurchaseOrderCommentValues>;
  onSubmit: (data: PurchaseOrderCommentValues) => void | Promise<void>;
  isSubmitting?: boolean;
  children?: React.ReactNode;
};

export function PurchaseOrderMainCommentForm({
  control,
  handleSubmit,
  onSubmit,
  isSubmitting,
  children,
}: PurchaseOrderMainCommentFormProps) {
  const { t } = useTranslation('common');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextareaControlled
        control={control}
        id='commentValue'
        name='value'
        placeholder=''
      />
      <div className='flex justify-end gap-2'>
        {children}
        <Button disabled={isSubmitting} type='submit'>
          {t('save')}
        </Button>
      </div>
    </form>
  );
}
